export const localKeyGenByVedaKeysOfAnimateInOutField = 'KeyGenByVedaKeysOfAnimateInOutField';
